/*
  PDP pricing block (A/B test) — replaces GemPages' price row with the tested design.
  Paired with snippets/pdp-price-block.liquid (emits #pdp-price-block-data) and
  pdp-price-block.css. Group comes from assets/pdp-price-ab-group.js.

  All money strings are formatted in Liquid and looked up per variant here — nothing is
  computed or formatted in JS, so the active market and currency are always respected.

  GemPages renders the price row as separate custom elements:
    <gp-product-price>  ×2  — the current price, and the compare-at price
    <gp-product-tag>        — the "SAVE …" tag
  All are hidden (not removed) so GemPages' own scripts keep hydrating normally, exactly
  as the dynamic-stock feature treats the stock row. Our card is inserted ahead of them.
*/
(function () {
  if (window.__ppbBound) return;
  window.__ppbBound = true;

  var dataEl = document.getElementById('pdp-price-block-data');
  if (!dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var VARIANTS = DATA.variants || {};
  var LABELS = DATA.labels || {};

  var HIDDEN = 'ppb-source-hidden';
  // A theme-native product page marks its own price row with data-ppb-source.
  var SOURCES = 'gp-product-price, gp-product-tag, [data-ppb-source]';
  var observer = null;
  var scheduled = false;

  /* ---------- variant ---------- */

  // Mirrors dynamic-stock.js: the form's id input is the single source of truth for
  // which variant is selected, whichever picker the page happens to use.
  function currentVariantId() {
    var atc = document.querySelector('button.gp-button-atc') || document.querySelector('button.m-add-to-cart');
    var form = atc && atc.closest('form');
    var scoped = form && form.querySelector('input[name="id"]');
    if (scoped && scoped.value) return String(scoped.value);

    var any = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    if (any && any.value) return String(any.value);

    try {
      var fromUrl = new URL(window.location.href).searchParams.get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (e) {}
    return null;
  }

  /* ---------- build + paint ---------- */

  function buildCard() {
    var card = document.createElement('div');
    card.className = 'pdp-price-block';
    card.setAttribute('data-ppb', '');
    card.innerHTML =
      '<div class="pdp-price-block__prices">' +
        '<div class="pdp-price-block__regular">' +
          '<span class="pdp-price-block__label"></span>' +
          '<s class="pdp-price-block__was"></s>' +
        '</div>' +
        '<div class="pdp-price-block__today">' +
          '<span class="pdp-price-block__label"></span>' +
          '<span class="pdp-price-block__now"></span>' +
        '</div>' +
      '</div>' +
      '<span class="pdp-price-block__badge"></span>';
    return card;
  }

  function paint(card, state) {
    card.querySelector('.pdp-price-block__regular .pdp-price-block__label').textContent =
      LABELS.regular || '';
    card.querySelector('.pdp-price-block__today .pdp-price-block__label').textContent =
      LABELS.today || '';
    card.querySelector('.pdp-price-block__was').textContent = state.regular || '';
    card.querySelector('.pdp-price-block__now').textContent = state.today || '';
    card.querySelector('.pdp-price-block__badge').textContent = state.saveText || '';
    // Not on sale → the regular column and the badge would be empty and the divider
    // would frame nothing, so collapse to just today's price.
    card.toggleAttribute('data-ppb-no-sale', !state.onSale);
  }

  function hideSources() {
    var sources = document.querySelectorAll(SOURCES);
    for (var i = 0; i < sources.length; i += 1) sources[i].classList.add(HIDDEN);
  }

  function showSources() {
    var hidden = document.querySelectorAll('.' + HIDDEN);
    for (var i = 0; i < hidden.length; i += 1) hidden[i].classList.remove(HIDDEN);
  }

  function anchor() {
    var first = document.querySelector('gp-product-price');
    if (!first) return document.querySelector('[data-ppb-source]');
    // Insert ahead of GemPages' own column wrapper so the card spans the full row
    // rather than being trapped inside a narrow flex column.
    return first.closest('[data-same-height-display-contents]') || first;
  }

  function attach(state) {
    var card = document.querySelector('[data-ppb]');
    if (!card) {
      var target = anchor();
      if (!target || !target.parentNode) return false;
      card = buildCard();
      target.parentNode.insertBefore(card, target);
    }
    // Re-asserted on every paint: a GemPages re-render swaps in fresh nodes that no
    // longer carry our class, which would bring the old price row back into view.
    hideSources();
    paint(card, state);
    return true;
  }

  function detach() {
    var cards = document.querySelectorAll('[data-ppb]');
    for (var i = 0; i < cards.length; i += 1) cards[i].remove();
    showSources();
  }

  /* ---------- group + scheduling ---------- */

  // Null until Intelligems (or a QA override) has said which arm this shopper is in.
  // The resolver owns the <html> stamp and the CSS does the hiding, so all this has to do
  // is not build the card yet. Fail safe to control if the resolver never loaded at all.
  function activeGroup() {
    if (!window.pdpPriceAb) return 'control';
    var group = window.pdpPriceAb.refresh();
    return window.pdpPriceAb.isDecided() ? group : null;
  }

  function render() {
    scheduled = false;
    if (observer) observer.disconnect();

    var group = activeGroup();
    if (group === null) {
      // Undecided — leave the area blank; the CSS `pending` rule is already hiding it.
      if (observer) observer.observe(document.body, { childList: true, subtree: true });
      return;
    }

    if (group !== 'variant') {
      detach();
    } else {
      var vid = currentVariantId();
      var state = vid ? VARIANTS[vid] : null;
      // Unknown variant (stale cache mid-deploy) → leave the theme's own price showing
      // rather than blanking the price or inventing one.
      if (state) attach(state);
      else detach();
    }

    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(render, 120);
  }

  function init() {
    observer = new MutationObserver(schedule);
    document.addEventListener('change', schedule, true);
    window.addEventListener('popstate', schedule);
    if (window.pdpPriceAb && typeof window.pdpPriceAb.onChange === 'function') {
      window.pdpPriceAb.onChange(schedule);
    }
    render();
    // Retries for late GemPages hydration — the price elements often are not in the DOM yet.
    [300, 800, 1500, 2500].forEach(function (t) {
      setTimeout(schedule, t);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
